import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ErrorContext } from './error-context.model';
import { HOST_URL } from 'app/shared/tokens/host-url';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {

  constructor(
    private http: HttpClient,
    @Inject(HOST_URL) private host: string
    ) {

  }

  logErrors(errors: ErrorContext[]): Observable<Object> {
    if(errors[0].status === 404) {
      return;
    }
    return this.http.post(`${this.host}/api/log-errors`, errors)
    .pipe(
      retry(3)
    );
  }
}
